"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateTypeEnum = void 0;
var RateTypeEnum;
(function (RateTypeEnum) {
    RateTypeEnum["PerTransactionRate"] = "perTransactionRate";
    RateTypeEnum["PackageMaterialRate"] = "packageMaterialRate";
    RateTypeEnum["MarkupRate"] = "markupRate";
    RateTypeEnum["MinimumRate"] = "minimumRate";
    RateTypeEnum["PredefinedManualRate"] = "predefinedManualRate";
})(RateTypeEnum = exports.RateTypeEnum || (exports.RateTypeEnum = {}));
